import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';

const CourseSelector = ({
    courses,
    selectedCourse,
    loading,
    disabled,
    onCourseChange
}) => {
    // debug: mostra i primi elementi e le chiavi disponibili
    if (courses && courses.length) {
        console.debug('CourseSelector received courses (keys):', Object.keys(courses[0]), 'sample:', courses.slice(0,3));
    } else {
        console.debug('CourseSelector received no courses');
    }
    return (
        <FormControl fullWidth sx={{ mb: 3 }} disabled={disabled}>
            <InputLabel id="course-select-label">Seleziona Corso</InputLabel>
            <Select
                labelId="course-select-label"
                value={selectedCourse}
                label="Seleziona Corso"
                onChange={(e) => onCourseChange(e.target.value)}
            >
                <MenuItem value="">-- Seleziona un corso --</MenuItem>
                {loading ? (
                    <MenuItem disabled>
                        <CircularProgress size={20} /> Caricamento...
                    </MenuItem>
                ) : courses.length === 0 && !disabled ? (
                    <MenuItem disabled>Nessun corso trovato</MenuItem>
                ) : (
                    courses.map((course) => {
                        const idVal = course.ID ?? course.id ?? course.Id ?? course.ID_CORSO ?? course.idcorso ?? course.ID_corso ?? course.IDCorso ?? null;
                        console.debug('Rendering MenuItem for course keys:', Object.keys(course), 'chosen id:', idVal);
                        if (idVal === null) {
                            // skip entries without a usable id
                            console.warn('Skipping course without id:', course);
                            return null;
                        }
                        return (
                            <MenuItem key={idVal} value={idVal}>
                                {course.post_title} - {course.data_inizio_corso}
                            </MenuItem>
                        );
                    })
                )}
            </Select>
        </FormControl>
    );
};

export default CourseSelector;
